import { useTranslation } from "react-i18next";
import { css } from "../../../../../styled-system/css";
import { VStack } from "../../../../../styled-system/jsx";
import DialogueCard from "../../../../modules/onboarding/components/DialogueCard";
import { useNavigate, createFileRoute } from "@tanstack/react-router";

const Summary = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["onboarding"]);

  return (
    <VStack
      css={{
        alignItems: "flex-start",
        width: "100%",
        maxWidth: { base: "100%", lg: "66.666%" },
        marginX: "auto",
        paddingY: "xlarge",
        textAlign: "start",
      }}
      gap="large"
    >
      <VStack gap="xsmall" alignItems="flex-start" width="100%">
        <h2 className={css({ fontWeight: "600" })}>{t(($) => $.onboarding.Thanks)}</h2>
        <p className={css({ fontSize: "xlarge" })}>
          {t(($) => $.onboarding["We have started loading and analyzing your data"])}
        </p>
      </VStack>

      <DialogueCard
        title={t(($) => $.onboarding["Continue to Dashboard"])}
        justify="center"
        onPress={() => {
          sessionStorage.setItem("showProfilesModal", "true");
          void navigate({ to: "/user/dashboard" });
        }}
      />
    </VStack>
  );
};

export const Route = createFileRoute("/_authenticated/onboarding/v2/summary")({
  component: Summary,
});
